@if (sadmClients().length === 1) {
  <button
    data-testid="client-action-button"
    tuiButton
    type="button"
    [appearance]="appearance()"
    [disabled]="disabled()"
    [iconStart]="icon()"
    [size]="size()"
    (click)="clientSelected.emit(sadmClients()[0])">
    {{ label() }}
  </button>
} @else {
  <button
    data-testid="client-action-button"
    tuiButton
    tuiChevron
    tuiDropdownAuto
    type="button"
    [appearance]="appearance()"
    [disabled]="disabled()"
    [iconStart]="icon()"
    [size]="size()"
    [tuiDropdown]="clientMenu">
    {{ label() }}
  </button>
  <ng-template #clientMenu>
    <pxc-menu-actions [actions]="menuActions()" />
  </ng-template>
}
